import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { func } from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/icons/Menu";

import { Grid } from "@material-ui/core";

import DesktopHeader from "./DesktopHeader";
import brandTheme from "brandTheme/Theme";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import CustomeSelect from "../CustomeSelect";
import { parseAndSetFlag } from "utils/Utils";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: brandTheme.headerBackGroundColor,
    width: "100%",
    flexWrap: "wrap",
    padding: "0 10px",
  },

  logoSection: {
    display: "flex",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      width: "100%",
    },
  },

  logo: {
    height: "60px",
    margin: "10px 0px 0px 20px",

    [theme.breakpoints.down("sm")]: {
      height: "45px",
      margin: "10px auto",
    },
  },

  mobileTopRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  mobileBranch: {
    width: "100%",
    padding: "10px",

    [theme.breakpoints.down("sm")]: {
      padding: "10px 0",
    },
  },
}));

const Header = ({
  handleDrawerToggle,
  userDetailsData,
  onReload,
  setBranchName,
  branchName,
  outletData,
  hideDrawer,
  notifications, 
  setNotifications
}) => {
  const classes = useStyles();
  const enableMultiBranch =
  parseAndSetFlag(outletData?.enableMultiBranchFlow) ||
  (outletData?.enabledMultiBranchAsPerUser || []).includes(
    userDetailsData?.designation
  );
  const [logo, setLogo] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);

  useEffect(() => {
    if (!logo) {
      GetLogoLink();
    }
  }, [logo]);

  const GetLogoLink = () => {
    setCallInProgress(true);

    apiHandler({
      url: endpoint.LOGO_URL,
      method: "GET",
    })
      .then((result) => {
        if (result?.data?.logo) {
          setLogo(result?.data?.logo);
        }
      })
      .catch((error) => {
        console.error("Logo API Error:", error);
      })
      .finally(() => {
        setCallInProgress(false);
      });
  };

  const handelChange = (e) => {
    setBranchName(e);
    onReload();
  };

  return (
    <Grid container className={classes.container}>
      {/* LOGO */}
      <Grid item xs={10} sm={10} md={5} className={classes.logoSection}>
        <Link to="/admin/dashboard" style={{ display: "block" }}>
          {logo && <img src={logo} alt="Logo" className={classes.logo} />}
        </Link>
      </Grid>

      {/* DESKTOP HEADER */}
      <Grid item xs={2} sm={2} md={7}>
        <Hidden smDown implementation="css">
          <DesktopHeader
            userDetailsData={userDetailsData}
            seletedBranchName={branchName}
            handelChange={handelChange}
            listData={userDetailsData?.branches}
            outletData={outletData}
            setNotifications={setNotifications} 
            notifications={notifications}
          />
        </Hidden>

        {/* MOBILE HEADER */}
       {!hideDrawer && <Hidden mdUp implementation="css">
          <div className={classes.mobileTopRow}>
            <IconButton
              aria-label="open drawer"
              onClick={handleDrawerToggle}
            >
              <Menu style={{ color: brandTheme.buttonHoverColor }} />
            </IconButton>
          </div>
        </Hidden>}
      </Grid>

      {/* MOBILE BRANCH SELECT */}
      {enableMultiBranch &&
        <Hidden mdUp implementation="css" fullWidth>
          <Grid item xs={12} sm={12} className={classes.mobileBranch}>
            <CustomeSelect
              label="Branch Name*"
              id="branch_name"
              value={branchName}
              setState={handelChange}
              data={userDetailsData?.branches}
            />
          </Grid>
        </Hidden>
      }

      {callInProgress && (
        <CircularProgresss callInProgress={callInProgress} />
      )}
    </Grid>
  );
};

Header.propTypes = {
  handleDrawerToggle: func,
};

export default Header;